// extracted by mini-css-extract-plugin
export var lg = "_13-4";
export var md = "_13-3";
export var sm = "_13-2";
export var xs = "_13-1";
export var xxs = "_13-0";